import React, { useEffect } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";

import "../styles/content.css";

const Content = ({ enabledCubes, cubeColors }) => {
    const { unityProvider, sendMessage, isLoaded } = useUnityContext({
        loaderUrl: "unity/Build/WebGLCBT-4(Build).loader.js",
        dataUrl: "unity/Build/WebGLCBT-4(Build).data.unityweb",
        frameworkUrl: "unity/Build/WebGLCBT-4(Build).framework.js.unityweb",
        codeUrl: "unity/Build/WebGLCBT-4(Build).wasm.unityweb",
    });

    useEffect(() => {
        if (isLoaded && enabledCubes.length > 0) {
            const cubeId = enabledCubes[0];
            const isEnabled = 1; // 활성화 상태를 Unity로 전달
            sendMessage("@Scene", "Move", isEnabled);
        }
    }, [enabledCubes, isLoaded, sendMessage]);

    useEffect(() => {
        if (isLoaded) {
            Object.entries(cubeColors).forEach(([cubeId, color]) => {
                const message = JSON.stringify({ ColorHex: color, ObjIndex: cubeId-1 });
                console.log(message)
                sendMessage("@Scene", "ChangeColor", message);  // 배열로 두 값을 전달
                console.log(`Cube ${cubeId} color sent to Unity: ${color}`);
            });
        }
    }, [cubeColors, isLoaded, sendMessage]);
    

    
    

    return (
        <div className="content">
            {!isLoaded && <div className="loading"></div>}
            <div
                className={`unity-container ${isLoaded ? "loaded" : ""}`}
                style={{
                    width: "900px",
                    height: "600px",
                    transition: "opacity 1s ease-in-out",
                    opacity: isLoaded ? 1 : 0,
                }}
            >
                <Unity unityProvider={unityProvider} className="unity" />
            </div>
        </div>
    );
};

export default Content;
